import { NullableOptional } from '../../common';
import { tuple } from '../../common/lang/tuple';

export const ALL_GOOGLE_ADWORDS_REPORT_TYPES = tuple('brandAwareness', 'conversions');

export type GoogleAdWordsReportType = typeof ALL_GOOGLE_ADWORDS_REPORT_TYPES[number];

export const ALL_GOOGLE_ADWORDS_REPORT_BY_TYPES = tuple('ad', 'keyword');

export type GoogleAdWordsReportByType = typeof ALL_GOOGLE_ADWORDS_REPORT_BY_TYPES[number];

/* Represents either an AdWords Ad or an AdWords Keyword */
export interface AdWordsEntityIdentityFields {
    /**
     * The ID of the entity in AdWords
     */
    adWordsId: string;
    label: string;
}

export interface AdWordsAdEntityFields {
    devicePreference: string;
    description: string;
    description1: string;
    description2: string;
}

export interface HasConversionTypeName {
    conversionTypeName: string;
}

export function getClickThroughRate(impressions: number, clicks: number): number {
    return impressions === 0 ? 0 : clicks / impressions;
}

export function getAdDisplayName(
    headline: NullableOptional<string>,
    headline1: NullableOptional<string>,
    headline2: NullableOptional<string>,
): string {
    if (headline) {
        return headline;
    }

    if (headline1) {
        if (headline2) {
            return `${headline1} - ${headline2}`;
        }

        return headline1;
    } else if (headline2) {
        return headline2;
    }

    return '';
}
